import React from 'react'
import styled from 'styled-components'
import { useEffect } from 'react'
const Div = styled.div`
  display: flex;
  flex-wrap: nowrap;
  width: 100%;
  margin: 25px 0;
  align-items: center;
  transition-property: transform;
  transition: 0.5s ease;
  &:hover {
      transform: translateY(-5px);
`
const Div2 = styled.div`
    display: flex;
    justify-content: center;
    margin: 25px;
    width: 100%;
    
`
const ShopBtn = styled.a`
  background-color: ${props => props.theme.mainColor};
  background-image: linear-gradient(to top left, ${props => props.theme.mainColorBlend}, ${props => props.theme.mainColor});
  color: ${props => props.theme.buttonForegroundColor};
  font-weight: 600;
  border-radius:3px;
  font-size: 16px;
  text-transform: uppercase;
  letter-spacing: 1px;
  border: 0;
  padding: 10px 15px;
  margin: 0 auto;
  outline: none;
  &:hover {
      text-decoration: none;
      color: ${props => props.theme.buttonForegroundColor};
      background-image: linear-gradient(to bottom right, ${props => props.theme.mainColorBlend}, ${props => props.theme.mainColor});
  }
`

const ConfiguratorBtn = styled(ShopBtn)`
  background-image: linear-gradient(to top left, ${props => props.theme.altButtonColorBlend}, ${props => props.theme.altButtonColor});
  &:hover {
    background-image: linear-gradient(to bottom right, ${props => props.theme.altButtonColorBlend}, ${props => props.theme.altButtonColor});
  }
`
export default function ShopProductBtn(props) {
    const {
        href,
        brandQuery
    } = props

    useEffect(() => {
        // brands=ABB%20Drives%2CABB%20Controls
        console.log("trigger", href ? href : `/search?searchTerm=${props.searchTerm}&sortType=relevancy&nonweb=false&resultPage=1&brands=${brandQuery ? brandQuery : props.searchTerm}`)
    }, [])

    return (
        <Div>
             {href ? (
                <ShopBtn href={ href ? href : `/search?searchTerm=${props.searchTerm}`}>{props.text}</ShopBtn>
                // <LinkStyle href={ href ? href : `/search?searchTerm=${searchTerm}`} target="_blank" rel="noopener noreferrer">

             ) : (
                <ShopBtn href={`/search?searchTerm=${props.searchTerm}&sortType=relevancy&nonweb=false&resultPage=1&brands=${brandQuery ? brandQuery : props.searchTerm}`}>{props.text}</ShopBtn>
             )
             }
        </Div>
    )
}

export function ProductConfiguratorBtn(props) {
    return (
        <Div2>
            <ConfiguratorBtn href={"https://blog.airlinehyd.com/tag/smc"} target="_blank"> SMC Blog Articles</ConfiguratorBtn>
            <ConfiguratorBtn href={"https://answers.airlinehyd.com/faq/kb-search-results?term=smc"} target="_blank"> SMC Frequently Asked Questions (FAQ)</ConfiguratorBtn>
            <ConfiguratorBtn href={props.url}>{props.text}</ConfiguratorBtn>

        </Div2>
    )
}

export function ContactUsBtn(props) {
    return (
        <Div2>
            <ConfiguratorBtn href={props.url}>Contat Us</ConfiguratorBtn>

        </Div2>
    )
}